import { render, staticRenderFns } from "./AccrualsConfigurationTabs.vue?vue&type=template&id=31c40274&scoped=true"
import script from "./AccrualsConfigurationTabs.vue?vue&type=script&lang=js"
export * from "./AccrualsConfigurationTabs.vue?vue&type=script&lang=js"
import style0 from "./AccrualsConfigurationTabs.vue?vue&type=style&index=0&id=31c40274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c40274",
  null
  
)

export default component.exports